export default __webpack_public_path__ + "static/media/Map3-2.7f1f65cb.png";